import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NO_MANIFEST_CARGO_ITEM_TO_ITINERARY } from '../../../../config/messages';
import Loader from '../../../common/Loader';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { CARGO_ITEM_RELOCATION_FILTER_COLUMNS } from '../../../../config/columns';
import Table from '../../../common/Table';
import Alert from '../../../common/informative/Alert';
import RelocationCargoItemToolbar from './RelocationCargoItemToolbar';
import { clearCargoItems, clearManifestItems } from '../../../../actions';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';

const RelocationCargoItemResult = ({
  cargoItems,
  loading,
  dispatchClearManifestItem,
  dispatchClearCargoItems,
  locationId,
  location,
  onHandleClear,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearManifestItem();
      dispatchClearCargoItems();
    },
    [],
  );

  if (cargoItems.get('content') === 0) {
    if (loading) {
      return <Loader />;
    }
    return (
      <Alert type="warning" message={NO_MANIFEST_CARGO_ITEM_TO_ITINERARY} />
    );
  }

  const toolbar = (
    <RelocationCargoItemToolbar
      locationId={locationId}
      location={location}
      onHandleClear={onHandleClear}
    />
  );

  const data = cargoItems.get('content');
  const defaultPageSize = DEFAULT_PAGE_SIZE;

  return (
    <>
      <div className="mt-3">
        {toolbar}

        <div className="flex">
          <h4>Encomiendas de la Ubicación </h4>
        </div>
        <Table
          columns={CARGO_ITEM_RELOCATION_FILTER_COLUMNS}
          data={data}
          defaultPageSize={defaultPageSize}
          loading={loading}
          showPagination
          manual={false}
          filterable
          defaultFilterMethod={filterMethodCaseInsensitive}
        />
      </div>
    </>
  );
};

RelocationCargoItemResult.propTypes = {
  cargoItems: PropTypes.instanceOf(Immutable.List).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    customer: PropTypes.shape({
      fullName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchClearManifestItem: PropTypes.func.isRequired,
  locationId: PropTypes.number,
  location: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  dispatchClearCargoItems: PropTypes.func.isRequired,
  onHandleClear: PropTypes.func.isRequired,
};

RelocationCargoItemResult.defaultProps = {
  locationId: 0,
  location: null,
};

const mapStateToProps = ({ CargoUnit, authentication, ItineraryUnit }) => ({
  cargoItems: CargoUnit.CargoItem.getIn(['all', 'content']),
  loading: CargoUnit.CargoItem.getIn(['all', 'loading']),
  user: authentication.get('user') || undefined,
  itineraryCounter:
    ItineraryUnit.Itinerary.getIn(['current', 'content']) || undefined,
});

const mapDispatchToProps = {
  dispatchClearManifestItem: clearManifestItems,
  dispatchClearCargoItems: clearCargoItems,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RelocationCargoItemResult);
